<template>
    <div id="edit_staff">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="ui segment" v-if="is_initialized">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <div class="ui form" v-else>
                <div class="eight wide field">
                    <label>{{ $t('models.attributes.staffs.username') }}</label>
                    <input type="text" name="username" v-model="staff.username">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.password') }} <span>*</span></label>
                    <input type="password" name="password" v-model="staff.password">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.password_confirmation') }} <span>*</span></label>
                    <input type="password" autocomplete="off" name="password_confirmation" v-model="staff.password_confirmation">
                </div>
                <div class="eight wide field computer column">
                    <label>{{ $t('models.attributes.staffs.name') }}</label>
                    <input type="text" name="name" v-model="staff.name">
                </div>
                <div class="eight wide field computer column">
                    <label>{{ $t('models.attributes.staffs.phone') }}</label>
                    <input type="text" name="phone" v-model="staff.phone">
                </div>

                <div class="eight wide field">
                    <label>{{ $t('models.attributes.staffs.email') }}</label>
                    <input type="text" name="email" v-model="staff.email">
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.staffs.role') }} <span>*</span></label>
                    <select class="ui dropdown" v-dropdown v-model="staff.role_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="role in $store.state.provider.staffs_module.roles" :value="role.identity">{{ role.name }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.staffs.theme_name') }} <span>*</span></label>
                    <select class="ui dropdown" v-dropdown v-model="staff.theme_name">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="theme_name in $store.state.provider.theme_menu_keys" :value="theme_name">{{ $t('ui.theme_names.' + theme_name) }}</option>
                    </select>
                </div>
                <div class="field">
                    <label>
                        {{ $t('models.attributes.staffs.station') }}
                        <i
                            class="pointer remove circle red icon clear_dropdown"
                            v-if="staff.station_identity"
                            @click="
                                staff.station_identity = null;
                                $($refs.station_identity).dropdown('clear');
                            ">
                        </i>
                    </label>
                    <select class="ui dropdown" v-dropdown v-model="staff.station_identity" ref="station_identity">
                        <option value="">{{ $t('ui.general.please_select') }}</option>
                        <option v-for="station in $store.state.provider.stations" :value="station.identity">{{ station.name }}</option>
                    </select>
                </div>

                <div class="ui basic positive button" @click="update_staff">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'staffs'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "EditStaff",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            errors: [],
            staff: {},
        }
    },
    computed: {
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await this.fetch_staff()
            await this.form_validation()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_staff() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_staff).parse({
                "identity": this.$route.params.identity,
            })
            this.is_loading = true
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.staff = response.data.staff
                        this.staff.password = null
                        this.staff.password_confirmation = null
                    } else {
                        // this.$noty.error('無法取得staff')
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.staffs'),
                            })
                        )
                    }
                })
                .catch(error => {
                    // this.$noty.error('取得staff失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.staffs'),
                            reason: ': ' + error
                        })
                    )
                })
                .then(() => {
                    this.is_loading = false

                })
        },
        form_validation() {
            $('.ui.form').form({
                on: 'blur',
                fields: {
                    name: "empty",
                    username: "empty",
                }
            })
        },
        update_staff() {
            var data = this.staff

            this.errors = []
            if ( data.password != "" && (data.password != data.password_confirmation)) {
                var str = '密碼錯誤'
                this.errors.push(str)
                this.$noty.error(str)

            } else {
                delete data.password_confirmation

                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_staff_update).parse({
                    "identity": this.$route.params.identity,
                })

                this.is_loading = true
                axios.post(url, data, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            this.staff = response.data.staff
                            this.staff.password = null
                            this.staff.password_confirmation = null
                            this.$store.dispatch('provider/fetch_current_staff')
                            this.$store.dispatch('provider/fetch_current_staff_permissions')
                            this.$router.push({name: 'staffs'})
                        } else {
                            // this.$noty.error('更新 員工 失敗')
                            this.$noty.error(
                                this.$t('ui.notifications.error.update__name', {
                                    name: this.$t('models.staffs'),
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error.response)
                    })
                    .then(() => {
                        setTimeout(() => {
                            this.is_loading = false
                        }, 300)
                    })
            }
        }
    },
    components: {
        ErrorMessages,
    }
}
</script>

<style scoped lang="scss">
    @import "../../.assets/stylesheets/form.scss";
</style>
